module.exports = __webpack_public_path__ + "img/EMC.c1b4adba.svg";